
import { AdminTemplate, MerchantValueDatedTransactionsComponent } from "../../components";

export const MerchantValueDatedTransactions = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "Üye İşyeri Valör Tarihli İşlemler",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={true}>
            <MerchantValueDatedTransactionsComponent />
        </AdminTemplate>
    );
};

